export * from './getHorizontTags'
